import { WizardStep } from '@factorialco/deprecated-design-system'

import { DatevWizardData } from 'modules/payroll_integrations_datev_lauds/lib/types'

import { absencesStep } from './AbsencesStep'
import { businessUnitsStep } from './BusinessUnitsStep'
import { companyStep } from './CompanyStep'
import { departmentsStep } from './DepartmentsStep'
import { salaryTypesStep } from './SalaryTypesStep'

export const useDatevLaudsSteps = () => {
  let laudsSteps: (() => WizardStep<DatevWizardData>)[] = []
  laudsSteps = [companyStep, businessUnitsStep, salaryTypesStep, absencesStep, departmentsStep]

  return laudsSteps
}
